module.exports = __webpack_public_path__ + "media/images/xero-2bf1c7eb28e697a8b0ae0006ac747bc9.svg";